// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"SideBar_sidebar__20CzM","logo":"SideBar_logo__1HTAR","subtitle":"SideBar_subtitle__uJRBl"};